﻿function getSchedulerState(scheduler: kendo.ui.Scheduler) {
    const buttonGroups = $('[data-save-to-filters="true"]')
        .toArray()
        .reduce<Record<string, number>>((acc, el) => {
            const widget = $(el).data('kendoButtonGroup');
            const name = el.id;
            if (widget) {
                acc[name] = widget.selectedIndices[0] ?? 0;
            }
            return acc;
        }, {});

    return kendo.stringify({
        date: scheduler.date(),
        view: scheduler.view().name,
        buttonGroups
    });
}

function setSchedulerSettings(scheduler: kendo.ui.Scheduler) {
    const settings = window.getSchedulerSettings();

    if (settings) {
        const skipFirstRequest = (event: Event) => {
            event.preventDefault();

            scheduler.unbind('dataBinding', skipFirstRequest);
            scheduler.date(new Date(settings.date));
        };

        scheduler.bind('dataBinding', skipFirstRequest);

        $('[data-save-to-filters="true"]').each((_, el) => {
            const widget = $(el).data('kendoButtonGroup');
            const savedIndex = settings.buttonGroups?.[el.id];

            if (widget && savedIndex != null) {
                widget.select(savedIndex);
            }
        });

        scheduler.view(settings.view);
        scheduler.dataSource.read();
    }
}

function adjustSchedulerHeight() {
    $('.k-scheduler:not(.no-adjust)').each(function () {
        const scheduler = $(this);
        scheduler.css('height', `${innerHeight - (scheduler.offset()?.top ?? 0) - 15}px`);
        setTimeout(kendo.resize.bind(null, this, false));
    });
}

window.adjustSchedulerHeight = adjustSchedulerHeight;
window.getSchedulerState = getSchedulerState;
window.setSchedulerSettings = setSchedulerSettings;
